<template>
  <CRow>
    <CCol sm="12">

      <Fortschritt :datum="datum"/>

      <Kalenderwoche v-model="datum" />

      <!-- Suche v-model="suchwort"/-->
      <Summe :datum="datum"/>
      <Suche v-model="rechnungsnummer"/>
      <template v-if="user.tageskalenderAktiv">
        <Formular :datum="datum"/>
      </template>
      <template v-else>
        <div class="alert alert-info">
          Der Tageskalender wurde deaktiviert. Es können keine neuen Einträge mehr angelegt werden.
        </div>
      </template>
    </CCol>
  </CRow>
</template>

<script>
import moment from 'moment'
import Fortschritt from '@/components/Fortschritt'
import Kalenderwoche from '@/views/Tageskalender/components/Kalenderwoche'
import Suche from '@/views/Tageskalender/components/Suche'
import Summe from '@/views/Tageskalender/components/Summe'
import Formular from '@/views/Tageskalender/components/Formular'

export default {
  name: 'tageskalender-index',
  components: {
    Fortschritt,
    Kalenderwoche,
    Suche,
    Summe,
    Formular
  },
  props: {
    pdatum: String
  },
  data () {
    return {
      datum: new Date(),
      rechnungsnummer: '',
      suchwort: ''
    }
  },
  computed: {
    darkMode () {
      return this.$store.getters['coreui/darkMode']
    },
    user () {
      return this.$store.getters['security/user']
    }
  },
  mounted () {
    if (this.pdatum) {
      const ldatum = moment(this.pdatum).toDate()
      this.datum = ldatum
    }
  }
}
</script>
